import IframeSender from "~/ts/library/crossTabCommunication/talk/IframeSender";

const OperatorApplicationIframeSender = new IframeSender();
OperatorApplicationIframeSender.startListen();

export default OperatorApplicationIframeSender;

export const CLIENT_DIALOG_INIT_ACTION = "initClientDialog";
export const CLIENT_DIALOG_OPEN_CASCADE_MESSAGE_REPORT = "openCascadeMessageReport";

export interface ClientDialogInitActionResponseInterface {
    username: string,
    dialogId?: number,
    login: string,
    usernames: string[],
    checkAccessForOnlineRemoveDialogs: boolean
}

export interface ClientDialogOpenCascadeMessageReportActionPayloadInterface {
    cascadeMessageId: number
}